import { Button, Link, Stack, Typography } from '@mui/material';

import { links } from '@/localization';
import { BasetenPageEnum, usePageSwitcher } from '@/routes';

import { ModelAPIAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';

function EmptyState() {
  const goToPage = usePageSwitcher();

  function goToCreateModelAPIPage() {
    goToPage(BasetenPageEnum.CreateSharedEndpoint);
  }

  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={500} gap={4}>
        <ModelAPIAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t added any Model APIs yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Run OpenAI-compatible frontier models on demand, optimized for speed and efficiency on
            the Baseten Inference Stack.{' '}
            <Link href={links.basetenDocsModelAPIs} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        <Button variant="contained" color="primary" onClick={goToCreateModelAPIPage}>
          Explore Model APIs
        </Button>
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
